import * as React from 'react';

import Text, { TextColor, TextWeight } from 'components/Text';

type Props = {
  children?: string;
  success?: boolean;
  failure?: boolean;
};

export default function StatusText(props: Props) {
  const { success, failure, children } = props;
  let color: TextColor = 'chalkboard';
  let weight: TextWeight = 'normal';
  if (success) {
    color = 'atlas';
  } else if (failure) {
    color = 'apple';
    weight = 'semibold';
  }
  return (
    <Text weight={weight} color={color} capitalize>
      {children}
    </Text>
  );
}
